import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import ProductGroupModal from "@/Modals/WebDataManagement/MasterData/ProductGroups/Modal";
import React from "react";
import { columns } from "./Columns";
import { productGroupsMasterDataApi } from "@/apis/apis";

export default function ProductGroupsPage() {
  return (
    <MasterDataBaseTable
      label="Product Group"
      apiURL={productGroupsMasterDataApi}
      columns={columns()}
      ModalComponent={ProductGroupModal}
      importData={BASE_IMPORT_DATA.PRODUCT_GROUPS}
    />
  );
}
